import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from './environment.service';

@Injectable({
	providedIn: 'root'
})
export class GeoblockerService {

	geoBlocked: boolean = false;
	rubyGeoblock: boolean = false;
	genericGeoblock: boolean = false;
	// geoBlocked: Subject<boolean> = new Subject();
	// rubyGeoblock: Subject<boolean> = new Subject();
	// genericGeoblock: Subject<boolean> = new Subject();

	private firstInteraction = true;

	constructor(
		private envService: EnvironmentService,
		private http: HttpClient) { }

	geoCheck(): any {
		this.firstInteraction = false;
		return this.http
			.get<any>(this.envService.contentHost + '/v1/geocheck')
	}

	async isBlocked(): Promise<boolean> {
        return false;
		// if (this.firstInteraction) {
		// 		try {
		// 			const check = await lastValueFrom(this.geoCheck());
		// 			this.geoBlocked = false;
		// 			this.rubyGeoblock = false;
		// 			this.genericGeoblock = false;
		// 		} catch (e) {
		// 			if (e.status === 400) {
		// 				this.geoBlocked = true;
		// 				this.genericGeoblock = true;
		// 			}
		// 			if (e.error === 'RU-BY') {
		// 				this.rubyGeoblock = true;
		// 			}
		// 		}
		// }
		// return this.geoBlocked;
	 }

	getGeoBlockType(): object {
		return {
			rubyGeoblock: this.rubyGeoblock,
			genericGeoblock: this.genericGeoblock
		};
	}
}
